/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppNames } from '@app/models/AppNames';
import { Observable, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

import { AppErrorService } from '../services/app-error.service';
import { TokenService } from '../services/token.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly tokenService: TokenService,
    private readonly appErrorService: AppErrorService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      //retry(1),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          //Unauthorized redirects to error page
          //this.router.navigate(['error']);
          if (
            sessionStorage.getItem('appName') === AppNames.UNITY_EXPRESS &&
            !request.url.toLowerCase().endsWith('/token')
          ) {
            this.tokenService
              .getToken()
              .pipe(take(1))
              .subscribe({
                error: tokenError => {
                  console.error('Unable to obtain new token:', tokenError);
                }
              });
          }

          return throwError(error);
        }
        const suppressNotification = request.headers.has('error-whitelist');
        const suppressNadaError = request.headers.has('nada-error-whitelist');

        this.appErrorService.handleHttpError(
          error,
          request,
          suppressNotification,
          suppressNadaError
        );
        return throwError(error);
      })
    );
  }
}
